module.exports = __webpack_public_path__ + "static/media/camino_hacia_la_vuelta_de_la_democracia.3ec0ce8b.md";